import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api";

// Warm the cache for every tab the moment the user is authenticated, so
// navigation is instant and offline-friendly (data also cached by the SW).
const PREFETCH = [
  ["reference", "/meta/reference"],
  ["characters", "/characters"],
  ["campaigns", "/campaigns"],
  ["dashboard", "/dashboard"],
  ["dice-history", "/dice/history"],
  ["conditions", "/conditions"],
  [["spells", "", -1], "/spells", { search: "", level: -1 }],
  [["items", "", ""], "/items", { search: "", type: "" }],
];

export default function Prefetcher() {
  const qc = useQueryClient();
  useEffect(() => {
    PREFETCH.forEach(([key, url, params]) => {
      qc.prefetchQuery({
        queryKey: Array.isArray(key) ? key : [key],
        queryFn: async () => (await api.get(url, params ? { params } : undefined)).data,
      });
    });
  }, [qc]);
  return null;
}
